import _ from "lodash";
import ElementGroup from "./ElementGroup";

class BlockLayout {
  constructor(/** Array **/ elementData) {
    this.elementData = elementData;

    this.groups = [];
    this.elementGroupMap = {};

    this.backgroundElements = [];

    this.backgroundFilter = null;
    this.elementGroupStrategy = null;

    this.height = 0;
    this.width = 0;
  }

  setBackgroundFilter(/** Object **/ filter) {
    this.backgroundFilter = filter;
  }

  setElementGroupStrategy(/** Object **/ groupStrategy) {
    this.elementGroupStrategy = groupStrategy;
  }

  groupElements() {
    if (this.backgroundFilter) {
      let filter = _.bind(this.backgroundFilter.shouldFilter, this.backgroundFilter);
      this.backgroundElements = _.remove(this.elementData, filter);
    }

    if (this.elementGroupStrategy) {
      this.elementGroupStrategy.apply(this);
    }
  }

  getElementGroup(elementId) {
    return _.get(this.groups, _.get(this.elementGroupMap, elementId));
  }

  addElement(/** ElementGroup **/ group, elementId, element) {
    group.addElement(element);
    _.set(this.elementGroupMap, elementId, group.id);
  }

  createGroup(elementId, element) {
    let group = new ElementGroup();

    let len = this.groups.push(group);
    group.id = len - 1;

    group.addElement(element);

    _.set(this.elementGroupMap, elementId, group.id);

    return group;
  }

  sortGroups(/** Function **/ groupSortMethod) {
    _.each(this.groups, function (/** ElementGroup **/ group) {
      group.prepare();
    });

    if (groupSortMethod) {
      this.groups.sort(groupSortMethod);
    }
  }
}

export default BlockLayout;
